import { GlobalState } from 'store/types';

export const currentCollectionSelector = (state: GlobalState) => {
  return state.pages.insertProducts.singleCollection.collection;
};

export const currentCollectionItemsSelector = (state: GlobalState) => {
  return state.pages.insertProducts.singleCollection.collection.data?.items;
};
